module.exports = __webpack_public_path__ + "img/icon_lots_pod_review.d809b4dd.png";